<form [formGroup]="roleForm">

  <select
    name="role"
    formControlName="role"
    class="form-control form-control-solid"
  >
    <option value="user">User</option>
    <option value="admin">Admin</option>
  </select>

</form>

<div *nzModalFooter>
  <button class="btn btn-light-primary btn-sm me-2" (click)="destroyModal()">Cancel</button>
  <button
    type="button"
    (click)="submitRoleForm()"
    id="qrpay_sign_up_submit"
    class="btn btn-sm btn-theme"
  >
    <ng-container *ngIf="(submitting | async) === false">
      <span class="indicator-label">Update</span>
    </ng-container>
    <ng-container *ngIf="submitting | async">
        <span class="indicator-progress" [style.display]="'block'">
          Please wait...
          <span
            class="spinner-border spinner-border-sm align-middle ms-2"
          ></span>
        </span>
    </ng-container>
  </button>
</div>
